import React from 'react';
import PropTypes from 'prop-types';
import ReactDOM from 'react-dom';
import './index.scss';

import Button from 'common/components/button';
import DropdownMenu from 'common/components/dropdown-menu';

import {getClosestAncestorWithClass} from 'common/utils/dom-util';

export default class DropdownButton extends React.Component {
  static propTypes = {
    buttonChildren: PropTypes.any,
    buttonProps: PropTypes.object,
    dropdownChildren: PropTypes.any,
    dropdownProps: PropTypes.object,
    lazy: PropTypes.bool,
  };

  static defaultProps = {
    lazy: false,
  };

  constructor(props) {
    super(props);

    this.onDocumentClick = this.onDocumentClick.bind(this);
    this.toggle = this.toggle.bind(this);

    this.state = {
      expanded: false,
    };
  }

  getButton() {
    const buttonProps = {
      ...this.props.buttonProps,
      isDepressed: this.state.expanded,
      onClick: this.toggle,
    };

    const button = (
      <Button {...buttonProps}>{this.props.buttonChildren}</Button>
    );

    return button;
  }

  getDropdown() {
    if (this.props.lazy && !this.state.expanded) {
      return;
    }
    const dropdownProps = {
      ...this.props.dropdownProps,
      isVisible: this.state.expanded,
    };

    const dropdownClasses = [dropdownProps.className || ''];
    if (dropdownProps.menuPosition) {
      dropdownClasses.push(
        `DropdownButton-menu--${dropdownProps.menuPosition}`,
      );
    }
    dropdownProps.className = dropdownClasses.join(' ');

    return (
      <DropdownMenu {...dropdownProps}>
        {this.props.dropdownChildren}
      </DropdownMenu>
    );
  }

  hide() {
    this.setState({expanded: false});
    document.removeEventListener('click', this.onDocumentClick);
  }

  show() {
    this.setState({expanded: true});
    setTimeout(() => {
      document.addEventListener('click', this.onDocumentClick);
    });
  }

  toggle() {
    return this.state.expanded ? this.hide() : this.show();
  }

  render() {
    return (
      <div className={'DropdownButton'}>
        {this.getDropdown()}
        {this.getButton()}
      </div>
    );
  }

  onDocumentClick(clickEvent) {
    const el = clickEvent.target;
    const menuClass = 'DropdownMenu-menu';

    const clickedMenu = el.classList.contains(menuClass);
    const clickedMenuChild = Boolean(
      getClosestAncestorWithClass(el, menuClass),
    );

    if (!(clickedMenu || clickedMenuChild)) {
      this.hide();
    }
  }
}
